<template>
  <div class="hello">
    <!-- <div class="top">
      <img src="@/assets/gs-banner.jpg" alt="顶部广告" class="top-img">
    </div> -->
    <Header></Header>


    <div class="content_s clearfix">
      <el-row>
        <el-col>
          <div class="mag-contant clearfix">

            <div class="mag-img">
              <img :src="'http://iceo-magazine.oss-cn-qingdao.aliyuncs.com'+magazineData[0].cover" alt="封面">
            </div>
            <div class="mag-info" v-if="magazineData[0]">

              <h1>
                中国企业家 {{magazineData[0].year }}年第{{magazineData[0].issue_number }}期 总第{{magazineData[0].total_issue_number }}期
              </h1>
              <p>
                出版日期：{{magazineData[0].date }}
              </p>

              <div v-for="(col,key) in magazineData[3]"  :key="key" >
                <h2 v-if="key == 0">【{{col.column_name}}】 {{col.title.replace(/【.*?】/,"")}}</h2>
                <h3 v-if="key > 1 && key < 3 ">【{{col.column_name}}】 {{col.title.replace(/【.*?】/,"")}}</h3>
                <p v-if="key >= 1 && key < 2">{{magazineData[4][key-1][0]}}</p>
                <p v-if="key == 2">{{magazineData[4][key][0]}}</p>
              </div>
              
              <div class="mag-read">
                <button type="button" class="el-button el-button--default" @click="redirect_buy_input"><!----><!----><span>订阅杂志</span></button>
                <el-button type="info" plain  @click="redirect_to_magazinedetail(magazineData[5][0])">下一期</el-button>
                <el-button type="info" plain  @click="redirect_to_magazinedetail(magazineData[5][1])">上一期</el-button>
              </div>

            </div>
          </div>

        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="contant-list clearfix">


            <div class="mag-item" >
              <div class="item-info clearfix" v-for=" (da,k,index) in magazineData[2]" :key="k" v-if="index <= magazineData[6][0] ">
                <h2>
                  {{da.cloname}}<i class="el-icon-caret-right"></i>
                </h2>
                <div v-for="(vl,ke) in da.data" :key="ke" @click="redrect_tomagazine_artical(vl._uniquecode,magazineData[0]['date'])" class="magact-list">
                  <h3>{{vl.title.replace(/【.*?】/,"")}}</h3>
                  <p>{{da.summar_artical[ke][0]}} </p>
                </div>
              </div>
            </div>


            <div class="mag-item" >
              <div class="item-info  clearfix" v-for=" (da,k,index) in magazineData[2]" :key="k" v-if="index > magazineData[6][0]"> 
                <h2>
                  {{da.cloname}} <i class="el-icon-caret-right"></i>
                </h2>
                <div v-for="(vl,ke) in da.data" :key="ke" @click="redrect_tomagazine_artical(vl._uniquecode,magazineData[0]['date'])" class="magact-list">
                  <h3 >{{vl.title.replace(/【.*?】/,"")}}</h3>
                  <p>{{da.summar_artical[ke][0]}} </p>
                </div>
              </div>
            </div>


          </div>
        </el-col>
      </el-row>
    </div>
    <bbottom></bbottom>
  </div>
</template>

<script>
  import Header from "@/components/public/Header.vue"
  import bbottom from "@/components/public/bbottom.vue"
  export default {
    name: 'Mag',

    data() {
      return {
        activeName: 'first',
        //页面数据
        magazineData: [],
        //
      }
    },

    props: {},

    created(){
        this.getMagazineDetail()
    },
    mounted(){
      const date = new Date();
      this.nowDate = date.getFullYear() 
    },

    //页面初始化
    computed: {
      
    },
   
    methods: {

      redirect_buy_input(){
        window.open('https://j.youzan.com/8TeOPz')
      },

      //跳转杂志详情页面
      redrect_tomagazine_artical(uniqueid,dateStrings)
      {  
        var status = this.convertDateAndCompare(dateStrings)
        console.log("当前日期对比",status)

        if( status ){
          // this.$router.push({ path:'/magartical/' + uniqueid} )
          let routeData=this.$router.resolve({ path:'/magartical/' + uniqueid} )
          window.open(routeData.href, '_blank');
        }else{

          //提示用户杂志一年才能看
          this.$message({
            message: '最近12个月内的期刊内容暂不提供在线浏览，给您带来的不便敬请谅解。',
            type: 'warning',
            offset:20,
            customClass: 'custom-message-customize' 
          });
        }
      },

      convertDateAndCompare(dateStrings)
      {
        console.log(dateStrings)
        const parts = dateStrings.split('-');
        const year = parseInt(parts[0]);
        const month = parseInt(parts[1]); 
        const day = parseInt(parts[2]);

        const givenDate = new Date(year, month-1, day);
        if (isNaN(givenDate)) return false; 
        
        const futureDate = new Date(Date.UTC(year, month - 1, day));
        futureDate.setUTCMonth(futureDate.getUTCMonth() + 12);
        // const futureDate = new Date(givenDate);
        // futureDate.setMonth(futureDate.getMonth() + 12);
        
        if (givenDate.getDate() !== futureDate.getDate()) {
          futureDate.setDate(0);
        }
        const now = new Date();
        return now >= futureDate;
       
      },

      //跳转其他杂志
      redirect_to_magazinedetail(obj){

        if(!obj || obj._uniquecode == undefined){
          this.$message({
            message:'杂志已经到底啦！',
            type:'error',
            duration:2000,
            customClass: 'messageIndex'
          })
        }else{
          this.$router.push({ path:'/maglist/detail/' + obj._uniquecode} )
          this.getMagazineDetail()
        }                                                  
      },
      
      // 获取杂志详细文章函数
      getMagazineDetail(){
        var config = {
          method: 'GET',
          url: '/api/v1/magazine/details/'+ this.$route.params.uniqueid,
          headers: { 
            'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{

         this.$data.magazineData = res.data
          console.log('请求成功')
          
        }).catch(error=>{
          console.log('请求失败')
        })
      }

    },
    //组件引入
    components: {

      Header,
      bbottom
    },
  }

</script>

<style>

.messageIndex {

  z-index: 9999 !important;

}

.custom-message-customize{
  z-index: 1000000 !important;
}

</style>      
        
<style scoped>
  .custom-message-customize{
    z-index: 1000000 !important;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .content_s {
    width: 1200px;
    margin: 25px auto;
    color: #4b4b4b;
  }

  .img_s {
    width: 100%;
    border-radius: 6px;
  }

  .top {
    width: 1200px;
    margin: 0 auto;
  }

    .top img {
      display: block
    }

  .baomin {
    display: relative;
    width: 60%;
    height: 32px;
    border: white solid 2px;
    border-radius: 6px;
    text-align: center;
    color: white;
    position: absolute;
    top: 60%;
    left: 50%;
    margin-top: -50px;
    margin-left: -100px;
  }

  .fonts_bao {
  }

  .hello {
    color: rgb(58, 2, 2);
  }

  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .item h3 {
    color: #e85a50;
  }

  .icon_s {
    display: inline-block;
    width: 30px;
    height: 30px;
    background: #eea01e;
    text-align: center;
    line-height: 30px;
    border-radius: 10px;
    margin-right: 15px;
    /* color:#fa5c00; */
    color: white;
  }

  .text {
    font-size: 14px;
  }

  .item {
    padding: 18px 0;
  }

  .box-card {
    width: 100%;
    margin-bottom: 20px;
  }

  .el-row {
    margin-bottom: 0px;
  }

  .el-col {
    /* margin-right:30px; */
    border-radius: 4px;
  }

  /*最新杂志*/
  .last-mag {
    width: 1100px;
    padding: 40px 50px 0px;
    background-color: #f1f1f1;
    height: 426px;
    overflow: hidden;
  }

  .mag-l, .mag-r {
    width: 380px;
    float: left;
  }

  .act-list {
    padding-top: 0px;
    padding-bottom: 15px;
  }

    .act-list h1 {
      font-size: 30px;
      line-height: 30px;
      margin: 0px auto 25px;
    }

    .act-list h2 {
      font-size: 16px;
      line-height: 24px;
      margin: 0px auto 15px;
    }

    .act-list h3 {
      font-size: 20px;
      line-height: 22px;
      margin: 0px auto 8px;
      font-weight: normal;
    }

    .act-list p {
      font-size: 14px;
      height: 40px;
      line-height: 20px;
      margin: 0px auto;
      color: #999;
      padding-bottom: 15px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

  .el-icon-caret-right {
    vertical-align: baseline;
  }

  .mag-r {
  }

  .mag-m {
    width: 290px;
    float: left;
    margin: 0px 25px 0px;
  }

    .mag-m img {
      width: 100%;
      display: block;
    }


  .el-icon-caret-right:before {
    color: #bd0c16 !important;
    font-size: 16px !important;
    line-height: 20px
  }

  .mag-r .act-list .el-icon-caret-right:before {
    color: #bd0c16 !important;
    font-size: 30px !important;
    line-height: 30px
  }

  .el-button--default {
    background-color: #bd0c16;
    width: 130px;
    height: 40px;
    color: #ffffff;
    font-size: 18px;
    margin-top: 30px;
  }
.el-button--default:focus,.el-button--default:hover {
 background-color: #bd0c16;
 color:#fff
}
  .mag-list {
    width: 1200px;
    margin: 30px auto;
  }

  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    font-size: 18px !important;
    font-weight: normal !important;
  }

  .time-title {
    width: 100%;
    height: 50px;
    border: 1px solid #f1f1f1;
    border-left-width: 0px;
    border-right-width: 0px;
  }

    .time-title h2 {
      width: 120px;
      background-color: #bd0c16;
      font-size: 22px;
      color: #fff;
      display: inline-block;
      float: left;
      margin: 0px;
      line-height: 50px;
      text-align: center;
      font-weight: normal;
      height: 50px;
    }

  .year-list {
    width: 1020px;
    display: inline-block;
    margin: 0px 30px;
    float: left;
  }

  .item-mag {
    margin: 25px auto;
  }

    .item-mag .el-card {
      border: none;
      box-shadow: none;
    }

  .el-card {
    color: #4b4b4b !important;
  }

    .el-card h3 {
      margin: 0px;
      padding: 8px 2px 3px;
      font-size: 16px;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      height: 20px;
    }

    .el-card span {
      font-size: 14px;
      color: #999;
    }
  /*当期杂志*/
  .mag-contant {
    width: 1000px;
    padding: 60px 100px 60px;
    background: linear-gradient(0deg, #f9f9f9, #f9f9f9 40%, #f1f1f1);
    overflow: hidden;
  }

  .mag-img {
    width: 360px;
    float: left;
    position: relative;
  }

    .mag-img .tip-float {
      position: absolute;
      top: 0px;
      left: 0px;
    }

    .mag-img img {
      width: 100%;
      display: block;
    }

  .mag-info {
    width: 610px;
    float: left;
    margin-left: 30px;
    min-height: 434px;
    padding-bottom: 30px;
    position: relative;
  }

  .mag-read {
    position: absolute;
    left:0px;
    bottom:10px;
  }

  .mag-info h1 {
    font-size: 30px;
    line-height: 30px;
    margin: 10px auto 8px;
    color: #bd0c16;
  }

  .mag-info  h3 {
    font-size: 16px;
    font-weight: normal;
    line-height: 24px;
    margin: 0px auto;
   
  }

  .mag-info h2 {
    font-size: 22px;
    line-height: 24px;
    margin: 30px auto 0px;
    font-weight: normal;
  }

  .mag-info p {
    font-size: 14px;
    margin: 10px auto 20px;
    line-height: 22px;
  }

  .el-button--info.is-plain {
    height: 40px;
  }

  .contant-list {
    width: 1000px;
    margin: 0px auto;
    padding: 40px 100px;
    background: linear-gradient(0deg, #f1f1f1, #f1f1f1 40%, #f9f9f9);
    border-top: 12px solid #f1f1f1
  }

  .mag-item {
    width: 840px;
    padding: 0px 40px;
    display: block;
    float: left;
  }

  .item-info {
    width: 100%;
  }
  .magact-list{
    width: 50%;
    float:left;
    padding:10px;
    box-sizing: border-box;
  }
    .item-info h2 {
      width:100%;
      height: 20px;
      font-size: 20px;
      line-height: 24px;
      color: #bd0c16;
      margin: 20px auto 0px;
      padding-bottom: 8px;
      border-bottom: 1px solid #ccc;
    }

    .item-info h3 {
      font-size: 18px;
      margin: 20px auto 0px;
      font-weight: normal;
      cursor: pointer;
      /* color:darkorange; */
        overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp:1;

    }

    .item-info h3:hover{
      color:#bd0c16;
    }

    .item-info p {
      font-size: 14px;
      line-height: 24px;
      height: 48px;
      margin: 0 auto;
      color: #999;
          overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
</style>



// WEBPACK FOOTER //
// src/components/Maglist.vue